import { StringUtil } from '@root/shared/core'
import { type Column } from '@root/shared/ui-kit'

import type { WalletsTableColumnId } from '../atoms/reatom-user-wallets-table'
import type { WalletModel } from '@root/entities/wallet'

export const walletManagerTableColumns: Array<
  Column<WalletModel, WalletsTableColumnId>
> = [
  {
    id: 'check',
    header: () => <></>,
    render: () => <></>,
    width: 32,
  },
  {
    id: 'name',
    header: ({ t }) => StringUtil.capitalize(t('wallet_one')),
    render: () => <></>,
    minWidth: 100,
  },
  {
    id: 'address',
    header: ({ t }) => t('common.address'),
    render: () => <></>,
    minWidth: 100,
  },
  {
    id: 'transactions',
    header: ({ t }) => StringUtil.capitalize(t('transaction_other')),
    render: () => <></>,
    minWidth: 100,
  },
  {
    id: 'balance',
    header: ({ t }) => StringUtil.capitalize(t('common.balance')),
    render: () => <></>,
    sortable: true,
    minWidth: 120,
  },
  {
    id: 'assets',
    header: ({ t }) => StringUtil.capitalize(t('asset_other')),
    render: () => <></>,
    sortable: true,
    minWidth: 120,
  },
  {
    id: 'chart',
    header: () => '24h',
    render: () => <></>,
    width: 116,
  },
  {
    id: 'edit',
    header: () => <></>,
    render: () => <></>,
    width: 60,
    justify: 'end',
  },
]
